'use strict';

var _ = require('lodash');
var d3 = require('d3');
var Scales = function Scales(params, data) {
  var yMin = 0;
  var yMax = _.chain(data).map('data[0]').max().value() * 1.05;
  var x = d3.scale.ordinal().domain(_.map(data, 'code')).rangeBands([0, params.width], 0.33, 0.16);
  var y = d3.scale.linear().domain([yMin, yMax]).range([params.height, 0]);
  return {
    xScale: x,
    yScale: y
  };
};
Scales.$inject = [];
module.exports = Scales;